import React, { useState, useEffect } from 'react';
import './Home.scss';
import { getMarkerList, editMarker } from './../../api';

const Home = ({ signOut, user }) => {
  const [markers, setMarkers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedMarkers, setExpandedMarkers] = useState({});

  const toggleExpand = (id) => {
    setExpandedMarkers((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const [lastKey, setLastKey] = useState(null);

  const fetchMarkers = async (loadMore = false) => {
    try {
      setLoading(true);
      let allItems = [];
      let nextKey = loadMore ? lastKey : null;
      let calls = 0;
  
      while (calls < 5 && (calls === 0 || nextKey)) {
        const data = await getMarkerList(nextKey);
        allItems = [...allItems, ...data.items];
        nextKey = data.lastEvaluatedKey || null;
        calls++;
      }
  
      setMarkers((prev) =>
        loadMore ? [...prev, ...allItems] : allItems
      );
      setLastKey(nextKey);
    } catch (error) {
      console.error('Errore nel recupero dei marker:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMarkers();
  }, []);

  const handleDisapprove = async (id) => {
    try {
      await editMarker(id);

      setMarkers(prev =>
        prev.map(marker =>
          marker.id === id ? { ...marker, approved: false } : marker
        )
      );
    } catch (error) {
      console.error('Errore durante la disapprovazione:', error);
    }
  };

  return (
    <div className="home-container">
      <div className="top-bar">
        <h2>Benvenuto Admin</h2>
        <button className="logout-button" onClick={signOut}>Log Out</button>
      </div>

      <div className="marker-list">
        <h3>🗺 Lista Completa Marker</h3>
        {lastKey && (
          <div className="load-more-container">
            <button
              onClick={() => fetchMarkers(true)}
              className="load-more-button"
              disabled={loading}
            >
              {loading ? '⏳ Caricamento...' : '🔽 Carica altri marker'}
            </button>
          </div>
        )}
        {loading ? (
          <p className="no-markers">Caricamento...</p>
        ) : markers.length === 0 ? (
          <p className="no-markers">Nessun marker trovato</p>
        ) : (
          <div className="card-grid">
            {[...markers]
              .sort((a, b) => {
                // Prima separa approvati e non approvati
                if (a.approved === b.approved) {
                  // Se entrambi i marker hanno lo stesso stato, ordina per data in ordine decrescente
                  return new Date(b.createdAt) - new Date(a.createdAt);
                }
                // Metti gli approvati prima dei non approvati
                return a.approved ? -1 : 1;
              })
              .map((marker) => (
                <div key={marker.id} className={`marker-card ${marker.approved ? 'approved' : 'pending'}`}>
                  <div className="card-header">
                    <h4 className="marker-message">
                      {marker.message.length > 100 ? (
                        <>
                          {expandedMarkers[marker.id]
                            ? marker.message
                            : `${marker.message.substring(0, 100)}... `}
                          <span
                            className="toggle-read"
                            onClick={() => toggleExpand(marker.id)}
                          >
                            <br></br>
                            {expandedMarkers[marker.id] ? '🔽 Leggi meno' : '🔼 Leggi di più'}
                          </span>
                        </>
                      ) : (
                        marker.message
                      )}
                    </h4>
                    <span className={`status ${marker.approved ? 'approved' : 'pending'}`}>
                      {marker.approved && '✅ Approvato'}
                    </span>
                  </div>
                  <p><strong>Posizione:</strong> {marker.latitude}, {marker.longitude}</p>
                  <p><strong>Email:</strong> {marker.email}</p>
                  <p><strong>Data:</strong> {new Date(marker.createdAt).toLocaleString()}</p>
                  {marker.image && (
                    <div className="marker-image-container">
                      <img src={marker.image} alt="Marker" className="marker-image" />
                    </div>
                  )}
                  {marker.approved && (
                    <button className="disapprove-button" onClick={() => handleDisapprove(marker.id)}>
                      ❌ Disapprova
                    </button>
                  )}
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;